import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideSectionLabel,
  GuideLead,
  GuideCallout,
  GuideCard,
  GuideCardGrid,
} from "../GuideBlocks.js";

const MentalNoiseBeforeSleepSection = ({ heading, accentIndex = 2, getVisual, getAccent }) => (
  <GuidePanel sectionId="mental-noise-before-sleep" heading={heading} accentIndex={accentIndex} getVisual={getVisual} getAccent={getAccent}>
    <GuideLead>
      Many people notice mental noise most strongly at night. As external distractions fade, the
      mind begins replaying conversations, unfinished tasks, future worries, and unresolved
      emotions.
    </GuideLead>
    <GuideSectionLabel>Common experiences</GuideSectionLabel>
    <GuideCardGrid columns={3}>
      <GuideCard iconKey="thinking" title="Replaying meetings" />
      <GuideCard iconKey="communication" title="Imagining tomorrow's conversations" />
      <GuideCard iconKey="stress" title="Regretting past decisions" />
      <GuideCard iconKey="thinking" title="Planning for unlikely scenarios" />
      <GuideCard iconKey="energy" title="Ready for sleep but still reviewing the day" />
    </GuideCardGrid>
    <GuideCallout>
      Poor sleep is often not caused by a busy day — it is caused by an unfinished mind.
    </GuideCallout>
    <GuideCallout variant="amber">
      Recording open loops before bedtime — what happened, what you assumed, what remains to decide —
      reduces nighttime replay and improves next-day clarity.
    </GuideCallout>
  </GuidePanel>
);

export default MentalNoiseBeforeSleepSection;
